export const addElement = (id) => {
    const element = document.createElement('div');
    element.setAttribute('id', id);
    return element;
};
export const removeElement = (id) => {
    const element = document.getElementById(id);
    element?.remove?.();
};
export const addBodyClass = (className) => document.body.classList.add(className);
export const removeBodyClass = (className) => document.body.classList.remove(className);
